import { render, staticRenderFns } from "./ProyectosEditar.vue?vue&type=template&id=6f2462b1"
import script from "./ProyectosEditar.vue?vue&type=script&lang=js"
export * from "./ProyectosEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports